import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { BookDropOffComponent } from './book-dropoff.component';

const routes: Routes = [{ path: '', component: BookDropOffComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BookDropOffRoutingModule {}
